module.exports = __webpack_public_path__ + "img/b95d7d0.jpg";